module.exports = __webpack_public_path__ + "static/discussionapp2-85adc621602b02066d8deb7db543ebea.png";